export enum DATA_AND_TIME {
  "MM/DD/YYYY" = "MM/DD/YYYY",
  "DD.MM.YY" = "DD.MM.YY",
  "MM.DD.YYYY" = "MM.DD.YYYY",
  "h:mmA" = "h:mmA",
  "MM/DD/YYYY ; h:mmA" = "MM/DD/YYYY ; h:mmA",
}

export enum HTTP_STATUS_CODES {
  SUCCESS = "000",
  SUCCESS_WITH_NO_DATA = "001",
  BAD_REQUEST = "040",
  INVALID_ACCESS_TOKEN = "041",
  ACCESS_DENIED = "043",
  RESOURCE_NOT_FOUND = "044",
  METHOD_NOT_ALLOWED = "045",
  RETRY_FAILURE = "005",
}
